import React from 'react'
import Nav from '../components/nav'
import Products from '../components/products'
import Main from '../components/main'
import Navbar from '../components/navbar'

import Container1 from '../components/container1'
import Container2 from '../components/container2'
import Container3 from '../components/container3'
import Footer from '../components/footer'
export default function home() {
    return (
        <div >
            <Container1 />
            <Container2 />
            <Container3 />
            <Main />
            <Footer />
        </div>
    )
}
